import styled from "styled-components";
import { Box } from "@mui/material";
import { grey } from "@mui/material/colors";
export const StatusControlWrapper = styled(Box)`
	position: fixed;
	bottom: 0;
	z-index: 1000;
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 14px;
	min-width: 270px;
	width: fit-content;
	padding: 10px 12px 10px 18px;
	border-radius: 18px;
	background: rgba(24, 24, 26, 0.55);
	backdrop-filter: blur(16px) saturate(160%);
	-webkit-backdrop-filter: blur(16px) saturate(160%);
	border: 1px solid rgba(255, 255, 255, 0.14);
	box-shadow:
		0 10px 30px rgba(0, 0, 0, 0.25),
		0 2px 8px rgba(0, 0, 0, 0.18);
	margin-bottom: 14px;
	animation: status-control-in 0.35s ease both;

	.setting_content {
		display: flex;
		flex-direction: column;
		gap: 2px;
	}

	.setting_label {
		font-family: var(--openSans), sans-serif;
		font-size: 11px;
		font-weight: 700;
		text-transform: uppercase;
		letter-spacing: 0.8px;
		color: rgba(255, 255, 255, 0.6);
	}

	.setting_value {
		display: flex;
		flex-direction: column;

		.setting_circle {
			width: 12px;
		}

		svg {
			filter: drop-shadow(0 0 6px currentColor);
		}

		p {
			font-family: var(--poppins), sans-serif;
			font-size: 14px;
			font-weight: 600;
			color: #fff;
		}
	}

	.action {
		position: relative;
		padding-left: 14px;

		&::before {
			content: "";
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 1px;
			height: 26px;
			background: rgba(255, 255, 255, 0.16);
		}

		button {
			color: #fff;
			background: linear-gradient(
				135deg,
				${({ theme }) => theme.palette.secondary.light},
				${({ theme }) => theme.palette.secondary.dark}
			);
			font-weight: 700;
			border-radius: 999px;
			padding: 6px 18px;
			box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
			transition:
				transform 0.2s ease,
				box-shadow 0.2s ease,
				background 0.2s ease;

			&:hover {
				background: linear-gradient(
					135deg,
					${({ theme }) => theme.palette.secondary.light},
					${({ theme }) => theme.palette.secondary.dark}
				);
				transform: translateY(-2px);
				box-shadow: 0 6px 18px rgba(0, 0, 0, 0.32);
			}

			&:active {
				transform: translateY(0);
			}

			&:disabled {
				color: rgba(255, 255, 255, 0.7);
				background: ${grey[600]};
				box-shadow: none;
			}
		}
	}

	@keyframes status-control-in {
		from {
			opacity: 0;
			transform: translateY(10px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
`;
